import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _get from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { isNone } from '../../animation/utils/is-none.mjs';
import { getVariableValue } from './utils/css-variables-conversion.mjs';
import { isCSSVariableToken } from './utils/is-css-variable.mjs';
import { positionalKeys, isNumOrPxType, positionalValues } from './utils/unit-conversion.mjs';
import { findDimensionValueType } from './value-types/dimensions.mjs';
import { KeyframeResolver } from '../utils/KeyframesResolver.mjs';
import { makeNoneKeyframesAnimatable } from '../html/utils/make-none-animatable.mjs';
var DOMKeyframesResolver = /*#__PURE__*/function (_KeyframeResolver) {
  function DOMKeyframesResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
    _classCallCheck(this, DOMKeyframesResolver);
    return _callSuper(this, DOMKeyframesResolver, [unresolvedKeyframes, onComplete, name, motionValue, element, true]);
  }
  _inherits(DOMKeyframesResolver, _KeyframeResolver);
  return _createClass(DOMKeyframesResolver, [{
    key: "readKeyframes",
    value: function readKeyframes() {
      var unresolvedKeyframes = this.unresolvedKeyframes,
        element = this.element,
        name = this.name;
      if (!element || !element.current) return;
      _get(_getPrototypeOf(DOMKeyframesResolver.prototype), "readKeyframes", this).call(this);
      /**
       * If any keyframe is a CSS variable, we need to find its value by sampling the element
       */
      for (var i = 0; i < unresolvedKeyframes.length; i++) {
        var keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string") {
          keyframe = keyframe.trim();
          if (isCSSVariableToken(keyframe)) {
            var resolved = getVariableValue(keyframe, element.current);
            if (resolved !== undefined) {
              unresolvedKeyframes[i] = resolved;
            }
            if (i === unresolvedKeyframes.length - 1) {
              this.finalKeyframe = keyframe;
            }
          }
        }
      }
      /**
       * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
       * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
       * have a far bigger performance impact.
       */
      this.resolveNoneKeyframes();
      /**
       * Check to see if unit type has changed. If so schedule jobs that will
       * temporarily set styles to the destination keyframes.
       * Skip if we have more than two keyframes or this isn't a positional value.
       * TODO: We can throw if there are multiple keyframes and the value type changes.
       */
      if (!positionalKeys.has(name) || unresolvedKeyframes.length !== 2) {
        return;
      }
      var _unresolvedKeyframes = _slicedToArray(unresolvedKeyframes, 2),
        origin = _unresolvedKeyframes[0],
        target = _unresolvedKeyframes[1];
      var originType = findDimensionValueType(origin);
      var targetType = findDimensionValueType(target);
      /**
       * Either we don't recognise these value types or we can animate between them.
       */
      if (originType === targetType) return;
      /**
       * If both values are numbers or pixels, we can animate between them by
       * converting them to numbers.
       */
      if (isNumOrPxType(originType) && isNumOrPxType(targetType)) {
        for (var _i = 0; _i < unresolvedKeyframes.length; _i++) {
          var value = unresolvedKeyframes[_i];
          if (typeof value === "string") {
            unresolvedKeyframes[_i] = parseFloat(value);
          }
        }
      } else {
        /**
         * Else, the only way to resolve this is by measuring the element.
         */
        this.needsMeasurement = true;
      }
    }
  }, {
    key: "resolveNoneKeyframes",
    value: function resolveNoneKeyframes() {
      var unresolvedKeyframes = this.unresolvedKeyframes,
        name = this.name;
      var noneKeyframeIndexes = [];
      for (var i = 0; i < unresolvedKeyframes.length; i++) {
        if (isNone(unresolvedKeyframes[i])) {
          noneKeyframeIndexes.push(i);
        }
      }
      if (noneKeyframeIndexes.length) {
        makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name);
      }
    }
  }, {
    key: "measureInitialState",
    value: function measureInitialState() {
      var element = this.element,
        unresolvedKeyframes = this.unresolvedKeyframes,
        name = this.name;
      if (!element || !element.current) return;
      if (name === "height") {
        this.suspendedScrollY = window.pageYOffset;
      }
      this.measuredOrigin = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
      unresolvedKeyframes[0] = this.measuredOrigin;
      // Set final key frame to measure after next render
      var measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
      if (measureKeyframe !== undefined) {
        element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
      }
    }
  }, {
    key: "measureEndState",
    value: function measureEndState() {
      var _a;
      var element = this.element,
        name = this.name,
        unresolvedKeyframes = this.unresolvedKeyframes;
      if (!element || !element.current) return;
      var value = element.getValue(name);
      value && value.jump(this.measuredOrigin, false);
      var finalKeyframeIndex = unresolvedKeyframes.length - 1;
      var finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
      unresolvedKeyframes[finalKeyframeIndex] = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
      if (finalKeyframe !== null && this.finalKeyframe === undefined) {
        this.finalKeyframe = finalKeyframe;
      }
      // If we removed transform values, reapply them before the next render
      if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) {
        this.removedTransforms.forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            unsetTransformName = _ref2[0],
            unsetTransformValue = _ref2[1];
          element.getValue(unsetTransformName).set(unsetTransformValue);
        });
      }
      this.resolveNoneKeyframes();
    }
  }]);
}(KeyframeResolver);
export { DOMKeyframesResolver };